import { useDispatch } from 'react-redux';

import type { AppDispatch } from '../store';

// Use throughout the app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>();
